import axios from "axios";
import config from "../config.js";

let responseInterceptorId = null;

let authRedirectInProgress = false;

function getResolvedRequestUrl(error) {
  const cfg = error.config;
  if (!cfg) return "";
  if (cfg.url?.startsWith("http")) return cfg.url;
  const base = cfg.baseURL || config.baseURL || "";
  const path = cfg.url || "";
  return `${base}${path}`.replace(/([^:]\/)\/+/g, "$1");
}

function isPublicAuthRequestUrl(url) {
  if (!url || typeof url !== "string") return false;
  const lower = url.toLowerCase();
  const patterns = [
    "/auth/login",
    "/auth/",
    "/register",
    "/user/forgot/password",
    "/user/reset",
    "/reset-password",
    "/otp-verify",
  ];
  return patterns.some((p) => lower.includes(p));
}

export function installAxiosAuthInterceptor(getDispatch, getNavigate) {
  if (responseInterceptorId !== null) {
    axios.interceptors.response.eject(responseInterceptorId);
    responseInterceptorId = null;
  }

  responseInterceptorId = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      if (status !== 401 && status !== 403) {
        return Promise.reject(error);
      }

      if (error.config?.skipAuthRedirect === true) {
        return Promise.reject(error);
      }

      const requestUrl = getResolvedRequestUrl(error);
      if (isPublicAuthRequestUrl(requestUrl)) {
        return Promise.reject(error);
      }

      if (authRedirectInProgress) {
        return Promise.resolve({
          data: [],
          status: 200,
          statusText: "OK",
          headers: {},
          config: error.config,
        });
      }

      authRedirectInProgress = true;
      const dispatch = getDispatch();
      const navigate = getNavigate();
      if (typeof dispatch === "function") {
        dispatch({ type: "CLEAR_USER" });
      }
      if (typeof navigate === "function") {
        navigate("/login", { replace: true });
      }

      window.setTimeout(() => {
        authRedirectInProgress = false;
      }, 1500);

      return Promise.reject(error);
    },
  );

  return responseInterceptorId;
}

export function uninstallAxiosAuthInterceptor() {
  if (responseInterceptorId !== null) {
    axios.interceptors.response.eject(responseInterceptorId);
    responseInterceptorId = null;
  }
}
